import React, { useEffect, useState } from 'react';
import api from "~/services/api";
import { Label, Input, Select } from "~/componentes/CustomForm";
import ColoredFileInput from "~/componentes/CustomForm/FileInput/styles/ColoredFileInput";

import DocumentosList from "./DocumentosList";
import { Container } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";

function CreateEditContent({ mountedData }) {
  const [tipologias, setTipologias] = useState([]);
  const [paginas, setPaginas] = useState([]);
  const [arquivoDoc, setArquivoDoc] = useState(mountedData?.arquivo);
  const [fileDoc, setFileDoc] = useState();

  const [arquivoTransc, setArquivoTransc] = useState(mountedData?.arquivoTranscricao);
  const [fileTransc, setFileTransc] = useState();

  const [removeArquivos, setRemoveArquivos] = React.useState([]);

  useEffect(() => {
    api.get("/signed/empresa/gestaodocumentos/gestaodocumentos/tipologias").then((r) => setTipologias(r?.data));
  }, []);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let formData = new FormData();

        let thisData = {
          ...data,
          id: mountedData?.id,
          paginas: JSON.stringify(paginas),
        };

        for (const [key, value] of Object.entries(thisData)) {
          formData.set(key, value);
        }

        fileDoc && fileDoc.forEach((v, k) => {
          formData.set(k, v)
        });

        fileTransc && fileTransc.forEach((v, k) => {
          formData.set(k, v)
        });

        let response;
        if (mountedData?.id)
          response = await api.put("/signed/empresa/gestaodocumentos/gestaodocumentos/documento", formData);
        else
          response = await api.post("/signed/empresa/gestaodocumentos/gestaodocumentos/documento", formData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"} essa Tipologia, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"} essa Tipologia?`,
        successModal: `Tipologia ${mountedData?.id ? "atualizada" : "cadastrada"} com sucesso!`,
      }
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row">
          <Label title="Catalogação *" className="col s12 m8 l4">
            <Input name="catalogacao" required="true" defaultValue={mountedData?.catalogacao} />
          </Label>
          <Label title="Data *" className="col s12 m4 l2">
            <Input name="data" type="date" required="true" defaultValue={mountedData?.data} />
          </Label>
          <Label title="Local *" className="col s12 m4 l3">
            <Input name="local" required="true" defaultValue={mountedData?.local} />
          </Label>
          <Label title="Tipologia *" className="col s12 m4 l3">
            <Select
              isNumber
              list={{ list: tipologias, value: 'id', label: 'titulo' }}
              name="idTipologia"
              firstOption
              value={mountedData?.idTipologia}
              required={true}
            />
          </Label>
        </div>
        <div className="row">
          <Label title="Anexo" className="col s12 m6 l4">
            <ColoredFileInput
              name="anexo_doc"
              defaultFile={arquivoDoc}
              formFile={(fileData, thisFile) => {
                setFileDoc(fileData);
                setArquivoDoc({ fileOldName: thisFile.name })
              }}
              onDefaultFileRemove={(e) => e?.id && setRemoveArquivos((prev) => [...prev, e?.id])}
            />
          </Label>
          <Label title="Anexo Transcrição *" className="col s12 m6 l4">
            <ColoredFileInput
              name="anexo_transc"
              defaultFile={arquivoTransc}
              formFile={(fileData, thisFile) => {
                setFileTransc(fileData);
                setArquivoTransc({ fileOldName: thisFile.name })
              }}
              onDefaultFileRemove={(e) => e?.id && setRemoveArquivos((prev) => [...prev, e?.id])}
            />
          </Label>
        </div>
        <div className="row">
          <DocumentosList setter={setPaginas} defaultData={mountedData?.paginas || []} />
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
